import PropTypes from 'prop-types';
import React from 'react';
import ImageHero from '~/components/Generic/ImageHero';
import SimpleHero from './SimpleHero';

const ContentHero = React.memo(function ContentHero({ hero, primary, forwardSx }) {
  return hero.type === 'Simple' ? (
    <SimpleHero title={hero.title} subtitle={hero.subtitle} body={hero.body.body} image={hero.image} cta={hero.cta} />
  ) : (
    <ImageHero
      title={hero.title}
      titleBottom={hero.titleBottom}
      subtitle={hero.subtitle}
      body={hero.body}
      image={hero.image}
      alignment={hero.alignment}
      cta={hero.cta}
      primary={primary}
      titlePosition={hero.type === 'Overlap Top' ? 'Top' : 'Bottom'}
      invertColors={hero.type === 'Overlap Top' ? false : true}
      forwardSx={forwardSx}
    />
  );
});

ContentHero.propTypes = {
  primary: PropTypes.bool,
  hero: PropTypes.shape({
    type: PropTypes.oneOf(['Simple', 'Overlap Top', 'Overlap Bottom']),
    title: PropTypes.string,
    titleBottom: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.shape({
      fluid: PropTypes.object.isRequired,
    }).isRequired,
    cta: PropTypes.shape({
      text: PropTypes.isRequired,
      url: PropTypes.string,
      page: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    }),
    alignment: PropTypes.oneOf(['Left', 'Right']),
  }),
  forwardSx: PropTypes.shape({}),
};

ContentHero.defaultProps = {
  primary: false,
  forwardSx: {},
};

export default ContentHero;
